import { useParams } from 'react-router-dom'
import { toast, Flip } from 'react-toastify'
import { AppContext } from '../../AppContext'
import { useContext, useState, useEffect } from 'react'

const CreateUser = () => {
    const { id } = useParams()
    const [ post, setPost ] = useState(null)
    const { setLoading, hostBase } = useContext(AppContext)
    const [ canEdit, setCanEdit ] = useState(id ? false : true)

    const updateField = (e) => {
        let _post = {...post}
        _post[e.target.name] = e.target.value
        setPost(_post)
    }
    const doUpdate = (e) => {
        e.preventDefault()
        setLoading(true)
        let formData = new FormData()
        for(let key in post)
            formData.append(key, post[key])
        const token = localStorage.getItem('userToken')
        fetch(`${hostBase}/api/user/update/?token=${token}`, { method: 'POST', body: formData })
            .then(res => res.json())
            .then((data) => {
                if(data?.error)
                    toast.error(data.error, { theme: "colored", transition: Flip })
                else{
                    let _post = !id ? {} : {...post}
                    setPost(_post)
                    toast.success(data.state, { theme: "colored", transition: Flip })
                }
            })
            .catch((e) => { toast.error('Ocurrió un error al intentar crear el usuario administrador.', { theme: "colored", transition: Flip }) })
            .finally(() => setLoading(false))
    }
    
    useEffect(() => {
        if(post === null && id){
            setLoading(true)
            const token = localStorage.getItem('userToken')
            fetch(`${hostBase}/api/user/get/${id}/?token=${token}`)
                .then(res => res.json())
                .then((data) => {
                    if(data.length !== 0)
                        setPost(data)
                    else
                        toast.error('No se encontró información para este usuario.', { theme: "colored", transition: Flip })
                })
                .catch((e) => { toast.error('Ocurrió un error al intentar traer la información del usuario administrador.', { theme: "colored", transition: Flip }) })
                .finally(() => setLoading(false))
        }
        if(post !== null && !id)
            setPost(null)
    }, [])

    return (
        <form onSubmit={doUpdate}>
            <input type="hidden" name="uid" value={post?.uid || ''} />
            <h2 className={id && 'min' || ''}>{id ? 'Información' : 'Creación'} de usuario administrador.</h2>
            <a className={'button min'+(canEdit ? ' hidden' : '')} onClick={() => setCanEdit(true)} style={{margin: '0 0 6px auto'}}>Editar usuario</a>
            <div style={{width: '100%'}}></div>
            <div>
                <label htmlFor="name">Nombre completo</label>
                <input type="text" name="name" value={post?.name || ''} onChange={updateField} required disabled={!canEdit} readOnly={!canEdit} />
            </div>
            <div>
                <label htmlFor="email">Correo electrónico</label>
                <input type="email" name="email" value={post?.email || ''} onChange={updateField} required disabled={!canEdit} readOnly={!canEdit} />
            </div>
            <div>
                <label htmlFor="status">Estado</label>
                <select name="status" value={post?.status || ''} onChange={updateField} required disabled={!canEdit} readOnly={!canEdit}>
                    <option value="">Seleccionar</option>
                    <option value="1">Activo</option>
                    <option value="2">Inactivo</option>
                </select>
            </div>
            <button className={canEdit ? '' : 'hidden'} type="submit">{id ? 'Modificar' : 'Crear'} usuario</button>
        </form>
    )
}
export default CreateUser